import * as React from 'react';
import MenuBar from './menu';
const Layout = ({ header, currentLocaleCode, children, siblingsPages }) => {
  return (
    <div className="w-full">
      <MenuBar siblingsPages={siblingsPages} currentLocaleCode={currentLocaleCode} />
      <div>
        <header className="experiencefragment">{header}</header>
        <div id="main_content"></div>
        <main>{children}</main>
      </div>
    </div>
  );
};

export default Layout;
